/* Push-navigatie mobiel menu (Farfetch-stijl), AFGEPLAT tot max 2 stappen:
 *   tik "Heren" -> paneel schuift in met ALLE sub-items gegroepeerd
 *   (Schoenen = sectie-kopje, Sneakers/Loafers/Boots eronder als grote links; Kleding idem).
 * Dus geen aparte stap "Schoenen" meer. Grotere tap-targets omdat je doorschuift.
 * PROGRESSIVE ENHANCEMENT: faalt de push -> native accordion blijft werken (mm-push-on eraf).
 * Werkt op Focal's markup (li[data-level] + button[is=toggle-button] + collapsible-content).
 */
(function () {
  "use strict";

  var css =
    "#mobile-menu-drawer.mm-push-on .drawer__content{position:relative;overflow:hidden}" +
    // grotere hoofdrijen (laag 1)
    "#mobile-menu-drawer.mm-push-on .drawer__content > .mobile-nav > .mobile-nav__item > .mobile-nav__link{font-size:17px;padding-top:17px;padding-bottom:17px}" +
    // LAAG 1 -> schuift in als paneel
    "#mobile-menu-drawer.mm-push-on .mobile-nav__item[data-level='1'] > collapsible-content.collapsible{" +
      "position:absolute;top:0;left:0;right:0;bottom:0;height:auto!important;max-height:none!important;display:block!important;" +
      "background:#fff;transform:translateX(100%);transition:transform .32s cubic-bezier(.4,0,.2,1);" +
      "overflow-y:auto;z-index:3;padding:0 26px 24px;visibility:hidden}" +
    "#mobile-menu-drawer.mm-push-on .mobile-nav__item[data-level='1'] > collapsible-content.collapsible.mm-open{transform:translateX(0);visibility:visible}" +
    // DIEPERE lagen -> inline, altijd zichtbaar (geen extra stap)
    "#mobile-menu-drawer.mm-push-on .mobile-nav__item[data-level='2'] > collapsible-content.collapsible," +
    "#mobile-menu-drawer.mm-push-on .mobile-nav__item[data-level='3'] > collapsible-content.collapsible{" +
      "position:static!important;transform:none!important;visibility:visible!important;height:auto!important;max-height:none!important;display:block!important;padding:0;overflow:visible;z-index:auto}" +
    // laag-2 knop -> sectie-kopje (niet klikbaar om te schuiven)
    "#mobile-menu-drawer.mm-push-on .mobile-nav__item[data-level='2'] > button[is='toggle-button']{" +
      "pointer-events:none;text-transform:uppercase;letter-spacing:.1em;font-size:12px;font-weight:600;opacity:.5;padding:22px 2px 6px}" +
    "#mobile-menu-drawer.mm-push-on .mobile-nav__item[data-level='2'] > button .animated-plus{display:none}" +
    // ingeschoven paneel: één nette serif-kolom, uitgelijnd
    "#mobile-menu-drawer.mm-push-on .mobile-nav__item[data-level='1'] > collapsible-content .mobile-nav__link{font-family:'MM Cormorant','Cormorant Garamond',Georgia,serif;font-size:16px;line-height:1.2;letter-spacing:.006em;padding:10px 0;display:flex;justify-content:space-between;align-items:center;color:#1a1a1a;border-bottom:1px solid #eef1f0}" +
    "#mobile-menu-drawer.mm-push-on .mobile-nav__item[data-level='1'] > collapsible-content .mobile-nav__link::after{content:'\\203A';color:#cbcfcd;font-size:17px;line-height:1;margin-left:12px}" +
    "#mobile-menu-drawer.mm-push-on .mobile-nav__item[data-level='1'] > collapsible-content > ul.mobile-nav > li:first-child > .mobile-nav__link{color:#137a6b}" +
    "#mobile-menu-drawer.mm-push-on .mobile-nav__item[data-level='1'] > collapsible-content > ul.mobile-nav > li:last-child > .mobile-nav__link{border-bottom:0}" +
    "#mobile-menu-drawer.mm-push-on .mobile-nav__item[data-level='3'] > .mobile-nav__link{font-size:16.5px}" +
    // terug-knop
    "#mobile-menu-drawer .mm-back{display:flex;align-items:center;gap:7px;width:100%;border:0;" +
      "padding:12px 0 2px;cursor:pointer;color:inherit;position:sticky;top:0;background:#fff;z-index:2}" +
    "#mobile-menu-drawer .mm-back__arrow{font-size:26px;line-height:1;color:#137a6b;font-weight:400}" +
    "#mobile-menu-drawer .mm-back__label{font-size:12px;letter-spacing:.12em;text-transform:uppercase;font-weight:600;color:#137a6b}" +
    "#mobile-menu-drawer .mm-subhead{font-family:'MM Cormorant','Cormorant Garamond',Georgia,serif;font-size:21px;font-weight:500;color:#1a1a1a;margin:0 0 9px;padding:0 0 9px;border-bottom:1px solid #e7ebe9}" +
    "#mobile-menu-drawer .mm-subfoot{display:flex;flex-direction:column;margin-top:16px;border-top:1px solid #e7ebe9;padding-top:2px}" +
    "#mobile-menu-drawer .mm-subquick{display:flex;align-items:center;text-decoration:none;font-size:12px;letter-spacing:.1em;text-transform:uppercase;font-weight:600;padding:11px 0}" +
    "#mobile-menu-drawer .mm-subquick span{margin-left:auto;font-weight:400;font-size:15px}" +
    "#mobile-menu-drawer .mm-subquick--sale{color:#8f3a2f}" +
    "#mobile-menu-drawer .mm-subquick--new{color:#137a6b;border-top:1px solid #e7ebe9}";

  function injectCss() {
    if (document.getElementById("mm-push-css")) return;
    var s = document.createElement("style");
    s.id = "mm-push-css"; s.textContent = css;
    document.head.appendChild(s);
  }

  function init() {
    var drawer = document.getElementById("mobile-menu-drawer");
    if (!drawer || drawer.__mmPush) return;
    try {
      injectCss();
      drawer.__mmPush = true;
      drawer.classList.add("mm-push-on");
      var stack = [];

      drawer.addEventListener("click", function (ev) {
        var back = ev.target.closest(".mm-back");
        if (back) { ev.preventDefault(); ev.stopPropagation(); closeTop(); return; }
        var btn = ev.target.closest('button[is="toggle-button"]');
        if (btn && drawer.contains(btn)) {
          var li = btn.closest(".mobile-nav__item");
          var level = li && li.getAttribute("data-level");
          ev.preventDefault(); ev.stopPropagation();      // blokkeer altijd de accordion
          if (level === "1") {                             // alleen laag 1 schuift in
            var id = btn.getAttribute("aria-controls");
            var panel = id && document.getElementById(id);
            if (panel) openPanel(panel, btn);
          }
        }
      }, true);

      drawer.addEventListener("click", function (ev) {
        if (ev.target.closest('[data-action="close"]') ||
            (ev.target.classList && ev.target.classList.contains("drawer__overlay"))) {
          while (stack.length) closeTop();
        }
      });

      function openPanel(panel, btn) {
        if (!panel.querySelector(".mm-back")) {
          var title = (btn.textContent || "").replace(/\s+/g, " ").trim();
          var hdr = document.createElement("button");
          hdr.type = "button"; hdr.className = "mm-back";
          hdr.innerHTML = '<span class="mm-back__arrow">‹</span><span class="mm-back__label">Terug naar menu</span>';
          var head = document.createElement("p");
          head.className = "mm-subhead";
          head.textContent = title;
          panel.insertBefore(head, panel.firstChild);
          panel.insertBefore(hdr, panel.firstChild);
          var gp = panel.closest(".mm-panel");
          var g = gp ? gp.getAttribute("data-gender") : "dames";
          var gval = g === "heren" ? "Heren" : (g === "kids" || g === "kinderen") ? "Kids" : "Dames";
          var foot = document.createElement("div");
          foot.className = "mm-subfoot";
          foot.innerHTML =
            '<a class="mm-subquick mm-subquick--sale" href="/collections/summersale?filter.p.m.specs.gender=' + gval + '">Summer Sale<span>&#8594;</span></a>' +
            '<a class="mm-subquick mm-subquick--new" href="/collections/new-arrivals?filter.p.m.specs.gender=' + gval + '">Nieuw binnen<span>&#8594;</span></a>';
          panel.appendChild(foot);
        }
        panel.classList.add("mm-open");
        panel.scrollTop = 0;
        stack.push(panel);
      }
      function closeTop() { var p = stack.pop(); if (p) p.classList.remove("mm-open"); }
    } catch (e) {
      if (drawer) drawer.classList.remove("mm-push-on");
    }
  }

  if (document.getElementById("mobile-menu-drawer")) init();
  try {
    var mo = new MutationObserver(function () { if (document.getElementById("mobile-menu-drawer")) init(); });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* stil */ }
  document.addEventListener("DOMContentLoaded", init);
})();
